/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { FullscreenModal } from 'components/modals'
import { Content, ContentBody } from 'components/content'

const EditModal = ({ children, onClose, show, title }) => (
  <FullscreenModal
    show={show}
    onClose={onClose}
    render={titleId => (
      <Content>
        <ContentBody>
          <h1 id={titleId}>{title}</h1>
          {children({ onClose })}
        </ContentBody>
      </Content>
    )}
  />
)

EditModal.propTypes = {
  children: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  title: PropTypes.node.isRequired,
}

export default EditModal
